import { ReactNode } from "react";

import TierInfo from "components/TierInfo";
import { BillingTierFeature } from "types/generated";

const MULTI_VCS_TIER_IFO = "multiVCSTierInfo";

type VCSIntegrationsPageLayoutProps = {
  children: ReactNode;
};

const VCSIntegrationsPageLayout = ({ children }: VCSIntegrationsPageLayoutProps) => {
  return (
    <>
      <TierInfo
        type="callout"
        variant="promo"
        feature={BillingTierFeature.MultipleVcs}
        title="Concurrent VCS integrations"
        storageKey={MULTI_VCS_TIER_IFO}
      >
        Upgrade your plan to benefit from multiple concurrent VCS integrations of the same type.
      </TierInfo>

      {children}
    </>
  );
};

export default VCSIntegrationsPageLayout;
